import { getSCountryPending, getSCountrySuccess, getSCountryFail, createCountryPending, createCountrySuccess, createCountryFail, modifyCountryPending, modifyCountrySuccess, modifyCountryFail } from "./countryListSlice";
import { countryCreation, countryModify, fetchSingleCountry } from "../../../api/userApi";
import Swal from "sweetalert2";

export const newCountryCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createCountryPending());
        const result = await countryCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createCountrySuccess(result.message))
            : dispatch(createCountryFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error')
         //console.log(error);
         console.log(err.msg);
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createCountryFail(err.msg));
        
    }

}


export const countryModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyCountryPending());
        const result = await countryModify(frmDt);
        result.status === "success"
            ? dispatch(modifyCountrySuccess(result.message))
            : dispatch(modifyCountryFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error')
        dispatch(modifyCountryFail(err.msg));
    }

}



export const getSingleCountry = (id) => async (dispatch) => {
   console.log('act'+id);

   try {
    //call the api
   dispatch(getSCountryPending());
   const result = await fetchSingleCountry(id);
  // const userData=JSON.parse(result.user);
//console.log('CountryData ');
//console.log(result);
//console.log(result.countries);

//console.log('check user profile out if');
   if(result.countries[0] && result.countries[0].id){
   //console.log('check user profile');
       return dispatch(getSCountrySuccess(result.countries[0]));
   }
   dispatch(getSCountryFail("Country is not found"));

  
} catch (error) {
   dispatch(getSCountryFail(error));

}
   

}


